import { createIcon } from './utils/createIcon.js';

export default createIcon({
  paths: [
    'M10.5 15h2c.276 0 .5-.224.5-.5v-2c0-.276-.224-.5-.5-.5h-2c-.276 0-.5.224-.5.5v2c0 .276.224.5.5.5zm.5-2h1v1h-1v-1z',
    'M17.708 4.708l-2.416-2.416A.996.996 0 0 0 14.587 2H1.996c-.55 0-.997.446-.997.997v15.007c0 .55.446.997.997.997h15.003c.55 0 1-.446 1-.997V5.413c0-.264-.105-.518-.292-.705zM6 3h7v3H6V3zm8 15H5v-7h9v7zm3 0h-2v-7c0-.552-.448-1-1-1H5c-.552 0-1 .448-1 1v7c0 .001.001.002.001.003H2L1.997 3H5v3c0 .552.448 1 1 1h7c.552 0 1-.448 1-1V3h.586L17 5.413V18z',
  ],
  height: 20,
  width: 20,
});
